import {useInfiniteQuery} from '@tanstack/react-query';
import {fetchSelectorsCities, fetchSelectorsCountries, fetchSelectorsShops} from "../services/selectors";


export const useSelectorsCitiesQuery = (search: string | undefined, filter: any | undefined) => {
    const limit = 10;
    return useInfiniteQuery({
        queryKey: ['selectorCities', search],
        queryFn: ({
                      pageParam = {
                          limit: limit,
                          offset: 0
                      }
                  }) => fetchSelectorsCities(pageParam.limit, pageParam.offset, search),
        initialPageParam: {limit: limit, offset: 0},
        getNextPageParam: (lastPage, allPages) => {
            const nextOffset = allPages.flat().length;
            return lastPage.length !== 0 ? {limit: limit, offset: nextOffset} : undefined;
        },
    })
}

export const useSelectorsCountriesQuery = (search: string | undefined, filter: any | undefined) => {
    const limit = 10;
    return useInfiniteQuery({
        queryKey: ['selectorCountries', search],
        queryFn: ({
                      pageParam = {
                          limit: limit,
                          offset: 0
                      }
                  }) => fetchSelectorsCountries(pageParam.limit, pageParam.offset, search),
        initialPageParam: {limit: limit, offset: 0},
        getNextPageParam: (lastPage, allPages) => {
            const nextOffset = allPages.flat().length;
            return lastPage.length !== 0 ? {limit: limit, offset: nextOffset} : undefined;
        },
    })
}


export const useSelectorsShopsQuery = (search: string | undefined, filter: any | undefined) => {
    const limit = 10;
    return useInfiniteQuery({
        queryKey: ['selectorShops', search],
        queryFn: ({
                      pageParam = {
                          limit: limit,
                          offset: 0
                      }
                  }) => fetchSelectorsShops(pageParam.limit, pageParam.offset, search),
        initialPageParam: {limit: limit, offset: 0},
        getNextPageParam: (lastPage, allPages) => {
            const nextOffset = allPages.flat().length;
            return lastPage.length !== 0 ? {limit: limit, offset: nextOffset} : undefined;
        },
    })
}
